import {Component} from "react";
import {connect} from 'react-redux';
import {deleteUser} from "./Redux/Actions/user";

class Logout extends Component {
    componentDidMount () {
        this.props.deleteUser();

        this.props.history.push('/login');
    }

    render () {
        return null;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteUser: _ => dispatch(deleteUser())
    };
};

export default connect(null, mapDispatchToProps)(Logout);